<template>
  <div class="product" :style="{ width: width+'px', height: height+'px' }">
    <img id="background" class="capimg"
        :src="toolimages.background"
        @load="handleImageLoaded"
        alt="visual design tool" />
    <img id="customimg" class="moveable" v-if="lazy"
        v-lazy="design.image.path || toolimages.transparent"
        :style="movableStyle"
        ref="designImage"
        alt="" />
    <img id="customimg" class="moveable" v-else
        :src="design.image.path || toolimages.transparent"
        :style="movableStyle"
        ref="designImage"
        alt="" />
    <img id="foreground" class="capimg"
        :src="toolimages.mask"
        ref="background"
        alt="" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DesignView',
  components: {
  },
  props: {
    design: Object,
    toolimages: Object,
    lazy: Boolean,
  },
  data() {
    return {
      width: null,
      height: null,
      imagesLoaded: false,
    };
  },
  computed: {
    basePosition() {
      const pos = {};
      if (this.imagesLoaded) {
        const bgelt = this.$refs.background;
        pos.left = bgelt.scrollLeft;
        pos.top = bgelt.scrollTop;
        pos.width = bgelt.scrollWidth;
        pos.visibleWidth = bgelt.scrollWidth * this.toolimages.visibleW;
        pos.height = bgelt.scrollHeight;
        pos.visibleHeight = bgelt.scrollHeight * this.toolimages.visibleH;
        pos.centerX = pos.width / 2;
        pos.centerY = pos.height / 2;
      }

      // console.log('base position', pos);
      return pos;
    },
    movablePosition() {
      const pos = this.boxFromRelative(this.design.relativePosition);
      // console.log('movablePosition', pos);
      return pos;
    },
    movableStyle() {
      const pos = {};
      Object.keys(this.movablePosition).forEach((key) => {
        const val = this.movablePosition[key];
        pos[key] = `${val}px`;
      });
      // console.log('movableStyle', pos);
      return pos;
    },
    ...mapState([]),
  },
  // mounted() {
  //   console.log('mounted');
  //   this.checkImageLoad();
  // },
  // beforeUpdate() {
  //   this.imagesLoaded = false;
  // },
  // updated() {
  //   this.checkImageLoad();
  // },
  methods: {
    handleImageLoaded(event) {
      if (event) console.log('handleImageLoaded event:', event.target.scrollWidth, event.target.scrollHeight);
      else console.log('handleImageLoaded no event');

      if (this.$refs.background.scrollHeight > 0) {
        this.width = this.$refs.background.scrollWidth;
        this.height = this.$refs.background.scrollHeight;
        this.imagesLoaded = true;
      } else {
        console.log('image not yet loaded; registering callback...');
        setTimeout(this.handleImageLoaded, 200);
      }
    },
    imageAspectRatio() {
      const { naturalWidth, naturalHeight } = this.$refs.designImage;
      // console.log(naturalWidth, naturalHeight);
      const aspectRatio = naturalWidth / naturalHeight;
      return aspectRatio;
    },
    boxFromRelative(relative) {
      /* A relativePosition is centerX/Y, the proportion of visible base w/h away from center,
       * and weight/height, a proportion of the visible base w/h. Returns a CSS box of
       * top/left/width/height inside the base element.
       */
      // console.log('boxFromRelative', relative);
      const base = this.basePosition;
      // console.log('base', base);
      const box = {};
      if (base && relative) {
        box.width = base.visibleWidth * relative.width;
        box.height = base.visibleHeight * relative.height;
        // console.log('box w:', box.width, 'h:', box.height);

        const boxCenterX = base.centerX - (base.visibleWidth * relative.centerX);
        const boxCenterY = base.centerY - (base.visibleWidth * relative.centerY);
        // console.log('box centerX:', boxCenterX, 'centerY:', boxCenterY);
        box.left = boxCenterX - (box.width / 2);
        box.top = boxCenterY - (box.height / 2);
        // console.log('box left:', box.left, 'top:', box.top);

        // box.rot = base.rot;
      }
      // console.log('boxFromRelative => box:', box);
      return box;
    },
    relativeFromBox(box) {
      const base = this.basePosition;
      const relative = {};
      if (base) {
        relative.width = box.width / base.visibleWidth;
        relative.height = box.height / base.visibleHeight;

        const boxCenterX = box.left + (box.width / 2);
        const boxCenterY = box.top + (box.height / 2);
        relative.centerX = (base.centerX - boxCenterX) / base.visibleWidth;
        relative.centerY = (base.centerY - boxCenterY) / base.visibleHeight;

        relative.rot = 0;
      }
      return relative;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product {
  position: relative;
  width:100%;
  overflow: hidden;
}

.product img {
  position:absolute;
  top: 0;
  left: 0;
  width: 100%;
}
</style>
